import React from "react";

// Relative luminance per WCAG -> pick black or white text for max contrast (ADA).
function readableText(hex) {
  if (!hex) return "#0a0a0a";
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return "#0a0a0a";
  const ch = (i) => parseInt(h.slice(i, i + 2), 16) / 255;
  const lin = (c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  const L = 0.2126 * lin(ch(0)) + 0.7152 * lin(ch(2)) + 0.0722 * lin(ch(4));
  const contrastWhite = 1.05 / (L + 0.05);
  const contrastBlack = (L + 0.05) / 0.05;
  return contrastBlack >= contrastWhite ? "#0a0a0a" : "#ffffff";
}

/**
 * Color-coded, ADA-compliant profile-category pill (business profiles).
 * <CategoryBadge value="startup" references={references} />
 */
export function CategoryBadge({ value, references, className = "", testId }) {
  if (!value) return null;
  const item = (references?.profile_categories || []).find((x) => x.value === value);
  if (!item) return null;
  const color = item.color || "#64748b";
  return (
    <span
      className={`inline-flex w-fit items-center rounded-full px-2.5 py-0.5 text-xs font-[560] ${className}`}
      style={{ backgroundColor: color, color: readableText(color) }}
      data-testid={testId || "profile-category-badge"}
    >
      {item.label}
    </span>
  );
}
